import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
  Grid,
  Paper,
  Menu,
  MenuItem,
  ButtonBase,
  Avatar,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import dashboardType from "../../../store/dashboard_type";

// Components
import LogoSection from "../LogoSection";
import ProfileSection from "./ProfileSection";

// Images
import TempImage from "./../../../assets/images/icons/Temp.png";
import UPSImage from "./../../../assets/images/icons/Ups.png";
import DGImage from "./../../../assets/images/icons/Dg.png";
import WaterImage from "./../../../assets/images/icons/water.png";
import VoltImage from "./../../../assets/images/icons/ems.png";
import FireImage from "./../../../assets/images/icons/fire system.png";
import HvacImage from "./../../../assets/images/icons/hvac.png";
import VibImage from "./../../../assets/images/icons/vib.png";
import ShieldImage from "./../../../assets/images/icons/NBSafe.png";
import TransImage from "./../../../assets/images/icons/trans.png";
import CropImage from "./../../../assets/images/icons/crop.png";
import GasImage from "./../../../assets/images/icons/gas.png";
import AirImage from "./../../../assets/images/icons/aircompress.png";
import TruckImage from "./../../../assets/images/icons/truck.png";
import Solar from "./../../../assets/images/icons/solar.png";
import SteamImage from "./../../../assets/images/icons/steam.png";
import BoilerImage from "./../../../assets/images/icons/boiler.png";
import PumpsImage from "./../../../assets/images/icons/pumps.png";

// Assets
import { IconMenu2 } from "@tabler/icons";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  grow: { flexGrow: 0 },
  headerAvatar: {
    ...theme.typography.commonAvatar,
    ...theme.typography.mediumAvatar,
    transition: "all .2s ease-in-out",
    background: theme.palette.secondary.light,
    color: theme.palette.secondary.dark,
    "&:hover": {
      background: theme.palette.secondary.dark,
      color: theme.palette.secondary.light,
    },
  },
  boxContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      marginRight: "1%",
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: "1",
    },
  },
}));

const Header = ({ handleLeftDrawerToggle, currentIndex = 0 }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [steamBoilerAnchorEl, setSteamBoilerAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(false);

  // Initial tabs
  let initialTabsData = [
    // { label: "Energy", image: VoltImage, path: "/ems/home" },
    // { label: "Air Compressor", image: AirImage, path: "/air/home" },
    // { label: "Water", image: WaterImage, path: "/wms/home" },
    // { label: "DG", image: DGImage, path: "/dg/home" },
    // { label: "Transformer", image: TransImage, path: "/trans/home" },
    // { label: "Pump", image: PumpsImage, path: "/pump/home" },
    // { label: "UPS", image: UPSImage, path: "/bms/home" },
    // { label: "Temp", image: TempImage, path: "/temp/home" },
    // { label: "HVAC", image: HvacImage, path: "/hvc/home" },
    // { label: "Vibration", image: VibImage, path: "/vib/home" },
    { label: "Fire System", image: FireImage, path: "/fms/home" },
    // { label: "NBSafe", image: ShieldImage, path: "/nbs/home" },
  ];

  // let moreTabsData = [
  //   { label: "Gas Flow", image: GasImage, path: "/gas/home" },
  //   { label: "Agriculture", image: CropImage, path: "/agr/home" },
  //   { label: "FLMS", image: TruckImage, path: "/flms/home" },
  //   { label: "Solar", image: Solar, path: "/solar/home" },
  // ];

  // Admin dashboards have no tabs
  if (
    currentIndex === dashboardType.admin ||
    currentIndex === dashboardType.superAdmin ||
    currentIndex === dashboardType.supportAdmin
  ) {
    initialTabsData = [];
    // moreTabsData = [];
  }

  const showSteamBoilerTab = !(
    currentIndex === dashboardType.admin ||
    currentIndex === dashboardType.superAdmin ||
    currentIndex === dashboardType.supportAdmin
  );

  // Promote active "More" tab if matching URL
  // const matchingMoreIndex = moreTabsData.findIndex((tab) =>
  //   location.pathname.startsWith(tab.path)
  // );

  // if (matchingMoreIndex !== -1) {
  //   const activeMoreTab = moreTabsData[matchingMoreIndex];
  //   initialTabsData = [activeMoreTab, ...initialTabsData];
  //   moreTabsData = moreTabsData.filter((_, i) => i !== matchingMoreIndex);
  // }

  // Update active tab
  useEffect(() => {
    const idx = initialTabsData.findIndex((tab) =>
      location.pathname.startsWith(tab.path)
    );
    setActiveTab(idx !== -1 ? idx : false);
  }, [location.pathname, initialTabsData]);

  const handleOpenMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleSteamBoilerOpen = (event) => {
    setSteamBoilerAnchorEl(event.currentTarget);
  };

  const handleSteamBoilerClose = () => {
    setSteamBoilerAnchorEl(null);
  };

  const handleRedirect = (path) => {
    history.push(path);
    handleCloseMenu();
    handleSteamBoilerClose();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        borderBottom: "1px solid #e8e8e8",
        backgroundColor: "#fff",
        px: 2,
      }}
    >
      {/* Left: Logo */}
      <div className={classes.boxContainer}>
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
        >
          <LogoSection />
        </Box>

        <ButtonBase
          sx={{
            display: { xs: "block", md: "none" },
            borderRadius: "3px",
            overflow: "hidden",
            padding: 0,
          }}
        >
          <Avatar
            variant="rounded"
            className={classes.headerAvatar}
            onClick={handleLeftDrawerToggle}
          >
            <IconMenu2 stroke={3.5} size="1rem" />
          </Avatar>
        </ButtonBase>
      </div>

      {/* Center: Tabs */}
      <Box sx={{ flex: 1,  minWidth: 0, display: "flex", justifyContent: "center",overflow: "hidden" }}>
        <Tabs
          value={activeTab === false ? false : activeTab}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: "48px",
            maxWidth: "100%",        
            "& .MuiTabs-scroller": {
              overflowX: "auto"
            },
            "& .MuiTab-root": {
              minHeight: "48px",
              padding: "4px 12px",
              textTransform: "none",
              flexShrink: 0
            }
          }}
        >
          {initialTabsData.map((tab, index) => (
            <Tab
              key={index}
              onClick={() => handleRedirect(tab.path)}
              icon={
                <Box display="flex" flexDirection="column" alignItems="center">
                  <img
                    src={tab.image}
                    alt={tab.label}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginBottom: "4px",
                    }}
                  />
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "clamp(10px, 1.2vw, 12px)",
                      textAlign: "center",
                    }}
                  >
                    {tab.label}
                  </span>
                </Box>
              }
              sx={{ minWidth: "auto", padding: "6px", flexShrink: 0 }}
            />
          ))}

          {/* Steam / Boiler Tab */}


          {/* More Tab */}
          {/* {moreTabsData.length > 0 && (
            <Tab
              onClick={handleOpenMenu}
              icon={
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Box
                    sx={{
                      width: 25,
                      height: 25,
                      border: "2px solid #1976d2",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#1976d2",
                      fontWeight: 700,
                      fontSize: "clamp(10px, 1.4vw, 13px)",
                      mb: 0.2,
                    }}
                  >
                    +{moreTabsData.length}
                  </Box>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "clamp(10px, 1.2vw, 12px)",
                      textAlign: "center",
                      color: "#1976d2",
                    }}
                  >
                    More
                  </span>
                </Box>
              }
              sx={{ minWidth: "auto", padding: "6px", flexShrink: 0 }}
            />
          )} */}
        </Tabs>
      </Box>

      {/* Right: Profile */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <ProfileSection />
      </Box>

      {/* Steam / Boiler Menu */}


      {/* More Menu */}
      {/* <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
        MenuListProps={{ sx: { padding: 1 } }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Grid container spacing={1} sx={{ width: 300, p: 1 }}>
          {moreTabsData.map((tab, index) => (
            <Grid item xs={4} key={index}>
              <Paper
                elevation={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 1,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
                onClick={() => handleRedirect(tab.path)}
              >
                <img
                  src={tab.image}
                  alt={tab.label}
                  style={{ width: "20px", height: "20px", marginBottom: "4px" }}
                />
                <span
                  style={{
                    fontSize: "clamp(10px, 1.2vw, 12px)",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    padding: "2px 0px",
                  }}
                >
                  {tab.label}
                </span>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Menu> */}
    </Box>
  );
};

export default Header;